module.exports = __webpack_public_path__ + "static/img/quick.518660a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quick.png
// module id = klIw
// module chunks = 0